import { getCurrentInstance } from 'vue';

/**
 * Composable for i18n translations in widget
 * Provides translation functions from vue-i18n
 *
 * @returns {Object} Object containing translation functions
 */
export function useI18n() {
  const instance = getCurrentInstance();
  const vm = instance?.proxy;

  if (!vm) throw new Error('useI18n must be called in setup');

  return {
    t: vm.$t.bind(vm),
    tc: vm.$tc.bind(vm),
    te: vm.$te.bind(vm),
    d: vm.$d.bind(vm),
    n: vm.$n.bind(vm),
  };
}
